import { Grid } from "@mui/material";
import EligibilityAccordions from "app/frontend/components/eligibility/EligibilityAccordions";
import Layout from "app/frontend/components/layouts/EligibilityLayout";
import Panel from "app/frontend/components/Panel";

const EligibilityAssessmentGuide = () => {
    return (
        <>
            <Grid container spacing={2} sx={{ my: { md: "50px" }, mx: { md: "100px" } }}>
                <Grid size={12}>
                    <Panel
                        sx={{
                            p: { xs: 0, md: "initial" },
                        }}
                    >
                        <EligibilityAccordions />
                    </Panel>
                </Grid>
            </Grid>
        </>
    );
};

EligibilityAssessmentGuide.layout = Layout;
export default EligibilityAssessmentGuide;
